import { clsx } from 'clsx'
import { Dispatch, SetStateAction } from 'react'
import ReactSwitch from 'react-switch'
import { useUiKit } from '../providers'
import styles from './Switch.module.scss'

const switchSizes = {
  default: {
    height: 24,
    width: 36,
    handleDiameter: 20,
    borderRadius: 16,
    iconSize: 10
  }
}

export interface SwitchProps {
  checked: boolean
  onClick: (() => null) | Dispatch<SetStateAction<boolean>>
  onColor?: string
  offColor?: string
  onIcon?: React.JSX.Element
  offIcon?: React.JSX.Element
  size?: keyof typeof switchSizes
  className?: string
}

export function Switch({
  checked,
  onClick,
  onColor,
  offColor,
  onIcon,
  offIcon,
  size = 'default',
  className
}: SwitchProps): JSX.Element {
  const switchSize = switchSizes[size]
  const { theme = { colorSwitch: '' } } = useUiKit()

  return (
    <ReactSwitch
      className={clsx(styles.Switch, className)}
      onChange={onClick}
      checked={checked}
      height={switchSize.height}
      width={switchSize.width}
      handleDiameter={switchSize.handleDiameter}
      borderRadius={switchSize.borderRadius}
      uncheckedIcon={false}
      checkedIcon={false}
      offColor={offColor || theme.colorSwitch}
      onColor={onColor || theme.colorSwitch}
      activeBoxShadow="none"
      uncheckedHandleIcon={
        offIcon || (
          <div className={styles.Icon}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 2C9 2.55228 8.55229 3 8 3C7.44772 3 7 2.55228 7 2C7 1.44772 8 0 8 0C8 0 9 1.44772 9 2ZM14 9C13.4477 9 13 8.55228 13 8C13 7.44772 13.4477 7 14 7C14.5523 7 16 8 16 8C16 8 14.5523 9 14 9ZM8 13C7.44772 13 7 13.4477 7 14C7 14.5523 8 16 8 16C8 16 9 14.5523 9 14C9 13.4477 8.55229 13 8 13ZM2 7C2.55228 7 3 7.44772 3 8C3 8.55229 2.55228 9 2 9C1.44772 9 0 8 0 8C0 8 1.44772 7 2 7ZM11.5355 4.46441C11.926 4.85494 12.5592 4.85494 12.9497 4.46441C13.3402 4.07389 13.6568 2.34309 13.6568 2.34309C13.6568 2.34309 11.926 2.65968 11.5355 3.0502C11.145 3.44072 11.145 4.07389 11.5355 4.46441ZM11.5356 12.9497C11.1451 12.5592 11.1451 11.926 11.5356 11.5355C11.9261 11.145 12.5593 11.145 12.9498 11.5355C13.3403 11.926 13.6569 13.6568 13.6569 13.6568C13.6569 13.6568 11.9261 13.3402 11.5356 12.9497ZM4.46451 11.5356C4.07398 11.1451 3.44082 11.1451 3.05029 11.5356C2.65977 11.9261 2.34319 13.6569 2.34319 13.6569C2.34319 13.6569 4.07398 13.3403 4.46451 12.9498C4.85503 12.5593 4.85503 11.9261 4.46451 11.5356ZM4.46441 3.05029C4.85494 3.44082 4.85494 4.07398 4.46441 4.46451C4.07389 4.85503 3.44072 4.85503 3.0502 4.46451C2.65968 4.07398 2.34309 2.34319 2.34309 2.34319C2.34309 2.34319 4.07389 2.65977 4.46441 3.05029ZM8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12Z"
                fill="white"
              />
            </svg>
          </div>
        )
      }
      checkedHandleIcon={
        onIcon || (
          <div className={styles.Icon}>
            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 9.85093C4.36704 8.78999 3.28131 6.90833 3.28131 4.76392C3.28131 2.85032 4.14589 1.14596 5.49239 0.0473246C5.27448 0.0161245 5.05193 0 4.82574 0C2.16062 0 0.000119209 2.23858 0.000119209 5C0.000119209 7.76142 2.16062 10 4.82574 10C5.23075 10 5.62411 9.9483 6 9.85093Z"
                fill="white"
              />
            </svg>
          </div>
        )
      }
    />
  )
}
